/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/* eslint-disable react-hooks/exhaustive-deps */

import { Loader, View, Text } from '@az/starc-ui'
import { Suspense, useEffect } from 'react'
import { useRoutes } from './useRoutes'
import { Layout } from '../components/Layout'
import { useAuthSessionStore } from '../shared/Auth2.0/stores/AuthSessionStore'
import { Routes, Route } from 'react-router-dom'
import { AuthSessionProvider } from '../shared/Auth2.0/providers/AuthSessionProvider'
import { useAuth } from '../shared/Auth2.0/useAuth'

const DEV_MODE = window.env.VITE_ENABLE_DEV_MODE === true

export const AppRouter = () => {
  const { routes } = useRoutes()
  const { isAuthenticated, login, logout, user } = useAuth()
  const { isSessionExpired } = useAuthSessionStore()

  useEffect(() => {
    if (isSessionExpired === true) {
      logout()
    } else {
      login()
    }
  }, [])

  useEffect(() => {
    if (!user) {
      return
    }
    if (user.roles.length === 0) {
      alert('You are not authorized to access this application.')
      if (DEV_MODE) {
        alert('You are in DEV mode. You can continue.')
      } else {
        logout()
      }
    }
  }, [user?.ignitionId])

  if (!isAuthenticated) {
    return (
      <View justify="center" align="center" height="100vh" width="100vw">
        <Loader variant="spinner" />
      </View>
    )
  }

  return (
    <AuthSessionProvider>
      <Layout hideNavigation={user?.roles.length == 0}>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {routes.map(route => {
              // Handle the case where component might be undefined
              if (!route.component) {
                return null
              }
              
              const Component = route.component
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<Component />}
                />
              )
            })}
          </Routes>
        </Suspense>
      </Layout>
    </AuthSessionProvider>
  )
}
